export default __webpack_public_path__ + "locales/si/Settings.json?hash=d946e933103e9ebefa530dd475441963";